<script>
import { defineComponent, onMounted, getCurrentInstance, watch, ref } from 'vue';
import msCombobox from './MsCombobox.vue';
import { useValidateControl } from '@/setup/validateControl.js';
import { MSConstant } from '@/commons/wildcards';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;

export default defineComponent({
  name: 'msComboboxEnum',
  extends: msCombobox,
  props: {
    enum: {
      default: null,
      type: String,
    },
    /**
     * @override
     */
    valueField: {
      type: String,
      default: 'enumValue',
    },
    /**
     * @override
     */
    displayField: {
      type: String,
      default: 'enumText',
    },

    values: {
      type: [Array, String],
      default: '',
    },

    /**
     * Custom dữ liệu
     */
    customData: {
      default: null,
      type: [Array, Function],
    },
    sortEnum: {
      type: [Boolean, String],
      default: false,
    },
  },

  setup(props) {
    //Variable
    const { proxy } = getCurrentInstance();
    const align = ref('left');
    const { errorMessage, handlerValidateCombobox, getTitleError, clearValidate, displayError, getValidateName } =
      useValidateControl({
        props,
      });
    const validate = (hasValidateSave, triggerDisplayError) => {
      if (!proxy.isGridEditor) {
        return handlerValidateCombobox(hasValidateSave, triggerDisplayError);
      }
      return '';
    };
    //Hooks
    onMounted(() => {
      loadEnumSource();
    });

    /**
     * Sử dụng watch này để có thể thay đổi Value ComboboxEnum
     * HQMINH 13.10.2022
     */
    watch(
      () => proxy.values,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          loadEnumSource();
        }
      }
    );
    //Method
    /**
     * Bổ sung values theo dạng text hoặc mảng để có thể filter theo enum
     * NCPHUOC 15/07/2022
     */
    const loadEnumSource = () => {
      let source = proxy.$ms.commonFn.getEnumSource(proxy.enum, proxy.values);
      if (proxy.sortEnum) {
        if (proxy.sortEnum == true || proxy.sortEnum == 'asc') {
          source = source.sort((a, b) => a.enumText - b.enumText || a.enumText.localeCompare(b.enumText));
        } else if (proxy.sortEnum == 'desc') {
          source = source.sort((a, b) => b.enumText - a.enumText || b.enumText.localeCompare(a.enumText));
        }
      }
      if (Array.isArray(source)) {
        let filterItems = [];
        if (Array.isArray(props.values)) {
          filterItems = props.values;
        } else {
          if (props.values) {
            filterItems = props.values.split(',');
          }
        }

        if (filterItems.length > 0) {
          const map = new Map();
          //Map lại để lấy cho nhanh
          filterItems.forEach(x => {
            map.set(x, 1);
          });
          source = source.filter(item => map.has(item.enumValue));
        }
      }
      /** Xử lý custom dữ liệu */
      if (proxy.customData) {
        if (Array.isArray(proxy.customData)) {
          source = proxy.customData.concat(source);
        }

        if (typeof proxy.customData == 'function') {
          source = proxy.customData(source);
        }
      }

      proxy._allData = source;

      proxy.internalDataSource = source;

      if (proxy.queryMode == 'remote') {
        proxy.loading = false;
      }
    };

    /**
     * Override lại hàm này, thêm set internal value trên comboboxenum
     */
    const setInitText = val => {
      proxy.internalText = proxy.initText ? proxy.initText : val;
      const sources = MSConstant[props.enum] || proxy.customData;
      if (Object.keys(sources)?.length > 0) {
        let value = null;
        if (props.enum) {
          for (const key in sources) {
            let enumText = i18n.t('i18nEnum.' + props.enum + '.' + key);
            if (val === enumText) {
              value = sources[key];
              break;
            }
          }
        }

        if (typeof value !== 'undefined' && value !== null) {
          proxy.setValueComboboxEnum(value); // ko gọi vào setValue nữa do hightlightItem đang có vấn đề, ko care được ảnh hưởng
        }
      }
    };

    const onClick = e => {
      if (proxy.selectOnly) {
        proxy.triggerClick();
      }
    };

    return {
      validate,
      errorMessage,
      getTitleError,
      onClick,
      setInitText,
      clearValidate,
      displayError,
      getValidateName,
      align
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsCombobox.scss';
</style>
